import React, { useContext, useEffect, useState } from 'react';
import { Context } from '../context/Context';
import axios from 'axios';
import { getHeaders, base } from '../Config';

export default function LangModal() {
    const { lang, handleLanguage, handleLangModal } = useContext(Context);
    const [selectedLang, setSelectedLang] = useState(localStorage.getItem("themeLang") || "fr");
    const [languageData, setLanguageData] = useState(null);

    useEffect(() => {
        // Fetch language data from appConfig API
        fetchLanguageData();
    }, []);

    const fetchLanguageData = async () => {
        try {
            const response = await axios({
                method: 'post',
                url: base + 'appConfig',
                headers: { ...getHeaders() },
            });
            if (response.data && response.data.language) {
                setLanguageData(response.data.language);
            }
        } catch (error) {
            console.error('Error fetching language data:', error);
        }
    };

    const closeLangModal = () => {
        handleLangModal(false);
    };

    const handleLanguageSelection = (langCode) => {
        setSelectedLang(langCode);
    };

    const handleContinue = () => {
        handleLanguage(selectedLang);
    };

    // Extract title, subtitle and langs from languageData
    const langDataObj = Array.isArray(languageData) ? languageData[0] : languageData;
    const title = langDataObj?.title || "Choisissez la langue";
    const subtitle = langDataObj?.subtitle || "Sélectionnez votre langue préférée ci-dessous. Cela nous permettra de mieux vous servir.";
    const langs = langDataObj?.langs || [];

    return (
        <div className='fixed inset-0 w-full h-full z-50 flex items-center justify-center p-4' style={{ backdropFilter: 'blur(4px)', WebkitBackdropFilter: 'blur(4px)' }}>
            <div className='w-full max-w-[560px] bg-white rounded-[20px] relative' style={{ boxShadow: '0 4px 20px rgba(0,0,0,0.15)' }}>
                {/* Close button */}
                <div 
                    className='absolute top-5 right-5 w-8 h-8 flex items-center justify-center cursor-pointer text-black text-3xl leading-none hover:opacity-70'
                    onClick={closeLangModal}
                >
                    ×
                </div>

                {/* Content Container */}
                <div className='p-8 pt-10'>
                    {/* Header */}
                    <div className='mb-8'>
                        <h2 className='text-2xl font-bold text-black mb-3'>
                            {title}
                        </h2>
                        <p className='text-base text-gray-600 leading-relaxed'>
                            {subtitle}
                        </p>
                    </div>

                    {/* Language Options */}
                    <div className='space-y-3 mb-6'>
                        {langs && langs.length > 0 && langs.map((language, index) => (
                            <div
                                key={index}
                                onClick={() => handleLanguageSelection(language.code)}
                                className={`
                                    flex items-center justify-between px-5 py-4 rounded-xl cursor-pointer transition-all
                                    ${selectedLang === language.code ? 'bg-yellow-400' : 'bg-gray-100 hover:bg-gray-200'}
                                `}
                                style={{ minHeight: '60px' }}
                            >
                                <span className='text-lg font-semibold text-black'>
                                    {language.lang}
                                </span>
                                {/* Radio/Checkbox */}
                                <div className={`
                                    w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0
                                    ${selectedLang === language.code ? 'bg-black' : 'border-2 border-gray-400'}
                                `}>
                                    {selectedLang === language.code && (
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.3337 4L6.00033 11.3333L2.66699 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Continue Button */}
                    <button
                        onClick={handleContinue}
                        className='w-full bg-yellow-400 hover:bg-yellow-500 text-black text-lg font-bold py-4 rounded-xl transition-colors'
                        style={{ minHeight: '56px' }}
                    >
                        Continuer
                    </button>
                </div>
            </div>
        </div>
    );
}
